export default __webpack_public_path__ + "static/media/companies.eae6cea0.webp";